export default "__VITE_ASSET__PtFMqAA___"